module.exports = __webpack_public_path__ + "img/logo_giped.ac5476dd.png";